/* eslint-disable */
import * as utilRegister from "@/api/register";

const state = {
    fields: {
        member_name: "",
        member_email: "",
        member_mobilephone: "",
        member_password: "",
        member_repeat_password: ""
    }
};


const mutations = {
    SET_fields: (state, value) => {
        state.fields = value
    },
};

const actions = {
    setFields({ commit }, data) {
        commit("SET_fields", data);
    },
    createValidation({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            utilRegister.createValidation(dataParams).then(response => {
                // const { data } = response;
                commit("SET_fields", dataParams);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            utilRegister.createStored(dataParams).then(response => {
                // const { data } = response;
                commit("SET_fields", dataParams);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/register.js